import classNames from "classnames";
import React, { useLayoutEffect, useState, useEffect } from "react";
import styles from "./AdCampaign.module.scss";

type Props = {
  size:
    | "half-page"
    | "md-rectangle"
    | "leaderboard"
    | "billboard"
    | "brand-half-page"
    | "brand-billboard"
    | "brand-leaderboard";
  className?: string;
  keywords?: string[];
};

const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;

export const AdCampaign: React.FC<Props> = (props) => {
  // Each of these properities can be found within the
  // zone tags provided for each zone configured. If adding
  // a new zone, extract ZoneId and Dimensions from the
  // appropriate Zone Tag.
  const [adId, dimensions, sizeClassName] = (() => {
    switch (props.size) {
      case "brand-half-page":
        return [479145, [300, 600], styles.brand_half_page];
      case "brand-billboard":
        return [479144, [970, 250], styles.brand_billboard];
      case "brand-leaderboard":
        return [479368, [970, 90], styles.brand_leaderboard];
      case "half-page":
        return [426699, [300, 600], styles.half_page];
      case "md-rectangle":
        return [424142, [300, 250], styles.md_rectangle];
      case "leaderboard":
        return [426697, [970, 90], styles.leaderboard];
      default:
        return [426698, [970, 250], styles.bard_billboard];
    }
  })();

  const [plcValue, setPlcValue] = useState<null | number>(null);

  const registerAdButlerScript = async () => {
    // @ts-ignore
    if (!window.AdButler) {
      await new Promise((resolve, reject) => {
        const script = document.createElement("script");
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src = "https://servedbyadbutler.com/app.js";
      });
    }

    // @ts-ignore
    const AdButler = window.AdButler || {};

    // @ts-ignore
    window.AdButler.ads = window.AdButler.ads || [];
    // @ts-ignore
    const abkw = props.keywords ? props.keywords.join(",") : window.abkw || "";
    // @ts-ignore
    var newPlcValue = window["plc" + adId] || 0;

    setPlcValue(newPlcValue);

    AdButler.ads.push({
      handler: function (opt) {
        AdButler.register(
          178486, // Ad Butler Account ID
          adId, // Zone Id
          dimensions, // Associated Dimensions
          `placement_${adId}_${opt.place}`,
          opt
        );
      },
      opt: {
        place: newPlcValue++,
        keywords: abkw,
        domain: "servedbyadbutler.com",
        click: "CLICK_MACRO_PLACEHOLDER",
      },
    });
  };

  useIsomorphicLayoutEffect(() => {
    registerAdButlerScript();
  }, []);

  if (plcValue === null) {
    return (
      <div
        className={classNames(styles.AdCampaign, styles.loading, sizeClassName)}
      ></div>
    );
  }

  const id = `placement_${adId}_${plcValue}`;
  return (
    <div
      className={classNames(
        styles.AdCampaign,
        sizeClassName,
        props.className || ""
      )}
    >
      <div className={styles.ad} id={id}></div>
    </div>
  );
};
